import { FormControl, InputLabel, Select, MenuItem, FormHelperText, Box, Alert } from "@mui/material";
import { GAMP_DICTIONARY, GampCategory, getGampEntry } from "../gampDictionary";
import { useAppSelector } from "../../../app/hooks";
import { selectSettings } from "../../settings/settingsSlice";

export function GampCategorySelect({
    value,
    onChange,
    error,
    helperText,
    label,
    showInfo = true,
}: {
    value: GampCategory | "";
    onChange: (v: GampCategory) => void;
    error?: boolean;
    helperText?: string | JSX.Element | null;
    label?: React.ReactNode;
    showInfo?: boolean;
}) {
    const { locale } = useAppSelector(selectSettings);
    const lang = locale === "pl" ? "pl" : "en";
    const current = value ? getGampEntry(value as GampCategory, lang) : undefined;

    const labelText = label ?? (lang === "pl" ? "Kategoria GAMP 5" : "GAMP 5 Category");
    const examplesLabel = lang === "pl" ? "Przykłady" : "Examples";
    const validationLabel = lang === "pl" ? "Poziom walidacji" : "Validation level";

    return (
        <FormControl fullWidth error={error} variant="outlined" size={"medium"}>
            <InputLabel id="gamp-label">{labelText}</InputLabel>
            <Select
                labelId="gamp-label"
                label={labelText}
                value={value === "" ? "" : (value as number)}
                onChange={(e) => onChange(Number(e.target.value) as GampCategory)}
            >
                {GAMP_DICTIONARY.map((entry) => {
                    const t = entry.text[lang];
                    return (
                        <MenuItem key={entry.key} value={entry.key}>
                            {t.label}
                        </MenuItem>
                    );
                })}
            </Select>

            {error && <FormHelperText>{helperText}</FormHelperText>}

            {/* Szczegóły tylko poniżej, po wybraniu kategorii */}
            {showInfo && current && (
                <Alert
                    severity="info"
                    sx={{
                        mt: 1,
                        "& .MuiAlert-message": { width: "100%" },
                        p: 1.25,
                        ".title": { fontWeight: 600, mb: 0.5 },
                        ".row": { mt: 0.5 },
                    }}
                >
                    <div className="title">{current.label}</div>
                    <div>{current.description}</div>
                    <div className="row">
                        <b>{examplesLabel}:</b> {current.examples}
                    </div>
                    <div className="row">
                        <b>{validationLabel}:</b> {current.validationLevel}
                    </div>
                </Alert>
            )}
        </FormControl>
    );
}
